import styled from 'styled-components';
import PropTypes from 'prop-types';

var maxWidth = function maxWidth(props) {
  return props.maxWidth ? {
    maxWidth: "".concat(props.maxWidth, "px")
  } : {
    maxWidth: props.theme.maxContainerWidth
  };
};

var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1vlg79k-0"
})(["margin-left:auto;margin-right:auto;", ";"], maxWidth);
Container.propTypes = {
  maxWidth: PropTypes.number
};
Container.displayName = 'Container';
export default Container;